var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 179,
    viewBox: "0 0 466 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-23.0174 145.301C-2.62742 239.013 122.575 291.336 256.631 262.168C390.686 233.001 482.83 133.386 462.44 39.6742C442.05 -54.0381 350.411 47.8943 216.355 77.0622C82.2997 106.23 -43.4074 51.5883 -23.0174 145.301Z",
    fill: "#4772F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse24);
export default __webpack_public_path__ + "static/media/Ellipse 24.63d4f992acd4b2d64bd45cd2f95096b3.svg";
export { ForwardRef as ReactComponent };